<template> 
<div class="open-opportunity-card card shadow-lg h-100">
    <router-link class="stretched-link" :to="`/open-opportunities/${item.id}`"></router-link>
    <div class="card-body h-100 d-flex flex-column justify-content-between">
        <div class="row g-2">
            <div class="col-12 d-flex justify-content-between"> 
                <div class="me-3">
                    <span style="white-space: wrap;" class="badge border-2 border text-primary">{{ item.friendly_id }}</span>
                    <h6 class="mt-3 mb-0">{{ item.company_name }}</h6>
                </div>
                <div>
                    <div class="position-relative d-inline-block mx-auto">
                        <img @click="showProfileImg(item.company_logo)" :src="absoluteUrl(item.company_logo)"
                        class="rounded-circle company-logo img-thumbnail cursor-pointer" :alt="item.title" />
                    </div>
                </div>
            </div>
            <div class="col-12 "> 
                <h4 class="">{{ item.title }}</h4>
            </div>
            <div class="col-12"> 
                <div class="row g-3">
                    <div class="col-6"> 
                        <span class="text-muted">Posted Date</span>
                        <h6> {{ $filters.date(item.started_at)}} </h6>
                    </div>
                    <div class="col-6"> 
                        <span class="text-muted">Deadline</span>
                        <h6> {{ $filters.date(item.closing_date)}} </h6>
                    </div>
                    <div class="col-12">
                        <label class="small text-muted">Contact Address </label>
                        <CommonAddress :item="item" />
                    </div>
                    <div v-if="item.qualifications.length" class="col-12">
                        <label class="small text-muted">Qualifications required </label>
                        <div class="">
                            <span v-for="(qualify, qIndex) in item.qualifications.slice(0,5)"
                            style="white-space: wrap;" class="me-2 text-start my-2 badge bg-soft-primary text-primary" :key="qIndex">
                            {{ qualify.title }} <span v-if="qualify.description">- {{ qualify.description }}</span></span>
                            
                            <span v-if="item.qualifications.length > 5" class="me-2 text-start my-2 badge bg-soft-primary text-primary">
                                +{{ item.qualifications.length - 5 }}</span>
                        </div>
                    </div>
                    <div v-if="item.skills.length" class="col-12">
                        <label class="small text-muted">Skills required </label>
                        <div class="">
                            <span v-for="(skill, skIndex) in item.skills.slice(0,5)"
                            style="white-space: wrap;" class="me-2 text-start my-2 badge bg-soft-primary text-primary" :key="skIndex">
                            {{ skill.title }}</span>
                            <span v-if="item.skills.length > 5" class="me-2 text-start my-2 badge bg-soft-primary text-primary">
                                +{{ item.skills.length - 5 }}</span>
                        </div>
                    </div>
                    <div v-if="item.courses.length" class="col-12">
                        <label class="small text-muted">Required course(s) of study </label>
                        <div class="">
                            <span v-for="(course, coIndex) in item.courses.slice(0,5)"
                            style="white-space: wrap;" class="me-2 text-start my-2 badge bg-soft-primary text-primary" :key="coIndex">
                            {{ course.title }}</span>
                            <span v-if="item.courses.length > 5" class="me-2 text-start my-2 badge bg-soft-primary text-primary">
                                +{{ item.courses.length - 5 }}</span>
                        </div>
                    </div>
                    <div v-if="item.short_description" class="col-12">
                        <label class="small text-muted">Brief Description </label>
                        <div v-html="preText(item.short_description)" class="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="d-grid d-sm-flex gap-3 mt-4">
                    <router-link class="btn w-100 btn-sm btn-outline-primary" :to="`/open-opportunities/${item.id}`">Read More</router-link>
                    <router-link v-if="item.opportunity_match" class="btn w-100 btn-sm btn-primary" :to="`/opportunities/${item.opportunity_match.id}`">View Status</router-link>
                    <router-link v-else class="btn w-100 btn-sm btn-primary" :to="`/open-opportunities/${item.id}`">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            required: true
        }
    }, 
}
</script>

<style>
.open-opportunity-card  .company-logo{
    height: 4.5rem;
    max-height: 4.5rem;
    width: 4.5rem;
    max-width: 4.5rem;
}
</style>